import React from 'react'
import { DrawerPosition, DrawerProps } from './Drawer.types'
import cn from 'classnames'

import styles from './Drawer.module.scss'

export const Drawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  children,
  topPosition = 0,
  position = DrawerPosition.left,
}) => {
  const getTopPosition = () => {
    return typeof topPosition === 'string' ? topPosition : `${topPosition}px`
  }

  return (
    <div>
      <aside
        className={cn(styles.drawer, {
          [styles.active]: isOpen,
          [styles.leftAligned]: position === DrawerPosition.left,
          [styles.rightAligned]: position === DrawerPosition.right,
          [styles.topAligned]: position === DrawerPosition.top,
        })}
        style={
          {
            '--top-position': getTopPosition(),
          } as React.CSSProperties
        }
      >
        {children}
      </aside>
      <div
        onClick={onClose}
        className={cn(styles.overlay, {
          [styles.active]: isOpen,
        })}
      />
    </div>
  )
}
